import { clicksConfig } from '../clicks';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const clicksMVConfig = {
    ...clicksConfig,
    tooltip: false,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
